import Login from '../src/components/pages/Login/Login';

export default function LoginPage() {
  return <Login />;
}
